import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';

class AddFundingTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            listOfApplications: ([{id:1, label: "Application 1"},{id:2, label: "Application 2"},{id:3, label: "Application 3"}]),
            listOfGrants: ([{id:1, label: "Grant 1"},{id:2, label: "Grant 2"},{id:3, label: "Grant 3"}]),
            selectedApplication: 0,
            selectedGrant: 0,
            note: "",
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {


    }

    render() {
        return (
            <div className={"universalAddTile"} style={{position: "relative"}}>
                <span className="fontPoppinsSemiBold15 clickable">Add Funding</span>

                <div style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20}}>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Application:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="application" id="application" style={{}} value={this.state.selectedApplication} onChange={e => this.setState({ selectedApplication: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfApplications.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Grant:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="grant" id="grant" style={{}} value={this.state.selectedGrant} onChange={e => this.setState({ selectedGrant: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfGrants.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: -5}}>Note:*</span>
                        <textarea className="modalInputAddNote" rows="4" style={{backgroundColor: "white"}} placeholder="" id="textAreaNote" name="textAreaNote" value={this.state.note} onChange={e => this.setState({ note: e.target.value })}></textarea>
                    </div>

                    <div className="horizontalStack" style={{paddingLeft: 20, paddingTop: 10, paddingRight: 25, paddingBottom: 20}}>
                        <RoundButton title={"Add Funding"} className={"roundButtonOrange"} onClick={this.createNewAction} whiteText={true} />
                    </div>
                </div>

            </div>
        );
    }
}

export default AddFundingTile;
